module.exports = __webpack_public_path__ + "media/images/indicators/magnitude_seca-f25d367b6404f2cd7c09e48bcb0c97d4.png";